import FlexBox from '@/atomic-components/FlexBox';
import React from 'react';
import { DimensionImage, Specifications } from './modal';
import SpecificationData from './specificationData';
import CrossIcon from '../../../../assets/pdp/crossIcon.svg';
import { Box, Drawer } from '@mui/material';
import { LencoImage } from '@/atomic-components/Image';

interface ISpecAndDesignProps {
	specification: Specifications;
	dimensionImages?: DimensionImage[];
	openSpecificationDrawer: boolean;
	setOpenSpecificationDrawer: Function;
}
const SpecificationAndDimensionDesignDrawerComponent = (
	props: ISpecAndDesignProps
) => {
	return (
		<Drawer
			anchor='right'
			open={props.openSpecificationDrawer}
			onClose={() => props.setOpenSpecificationDrawer(false)}
		>
			<Box sx={{ padding: '40px', width: '1000px' }}>
				<FlexBox
					sx={{
						cursor: 'pointer',
						justifyContent: 'end',
						paddingBottom: '24px',
					}}
				>
					<Box onClick={() => props.setOpenSpecificationDrawer(false)}>
						<CrossIcon />
					</Box>
				</FlexBox>
				<FlexBox
					sx={{
						justifyContent: 'start',
						alignItems: 'flex-start',
					}}
				>
					<Box sx={{ width: '50%' }}>
						{props?.dimensionImages && props?.dimensionImages?.length>0 && (
							<Box sx={{ width: '480px' }}>
								<LencoImage
									url={props.dimensionImages[0].url}
									aspectRatio={props.dimensionImages[0].aspectRatio}
								/>
							</Box>
						)}
					</Box>
					<FlexBox direction='column' sx={{ width: '50%' }}>
						<SpecificationData specifications={props.specification} />
					</FlexBox>
				</FlexBox>
			</Box>
		</Drawer>
	);
};

export default SpecificationAndDimensionDesignDrawerComponent;
